/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Views } from '../store';

const useStyles = makeStyles(({ spacing, palette }) => ({
  wrapper: {
    marginBottom: spacing(15),
  },
  steps: {
    borderRadius: 999,
    border: `1px solid ${palette.primary.main}`,
    display: 'inline-flex',
    overflow: 'hidden',
  },
  viewItem: {
    padding: '6px 14px',
    fontSize: '12px',
    borderRadius: 0,
    border: 'none',
    '&:focus-visible': {
      outline: `2px solid ${palette.secondary.main}`,
    },
    '&:hover': {
      backgroundColor: palette.background.secondary,
    },
  },
  active: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    '&:hover': {
      backgroundColor: palette.primary.light,
    },
  },
}));

const ViewSwitcher = ({ onSelect, selected }) => {
  const { t } = useTranslation('results');
  const { wrapper, steps, viewItem, active } = useStyles();

  return (
    <div className={wrapper}>
      <Box display="flex" alignItems="center" className={cx(steps)}>
        {Object.entries(Views).map(([key, value]) => (
          <Button
            key={key}
            variant="outlined"
            className={cx(viewItem, { [active]: selected === value })}
            onClick={() => {
              onSelect(value);
            }}
          >
            {t(`views.switcher.${value}`)}
          </Button>
        ))}
      </Box>
    </div>
  );
};

ViewSwitcher.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.oneOf(Object.values(Views)),
};

ViewSwitcher.defaultProps = {
  selected: Views.Business,
};

export default ViewSwitcher;
